var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload" },
    [
      _c(
        "el-upload",
        {
          ref: "upload",
          attrs: {
            disabled: _vm.disabled,
            action: _vm.action,
            "list-type": "text",
            "on-preview": _vm.handlePictureCardPreview,
            "on-remove": _vm.handleRemove,
            limit: _vm.limit,
            multiple: "",
            "on-success": _vm.handleSuccess,
            "auto-upload": true,
            headers: _vm.headers,
            "on-exceed": _vm.handleExceed,
            "on-change": _vm.handleChange,
            "before-upload": _vm.beforeAvatarUpload,
            accept:
              _vm.accept == "image"
                ? ".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
                : _vm.accept == "pdf"
                ? ".pdf,.PDF"
                : _vm.accept == "kmz"
                ? ".kmz,.KMZ"
                : "*",
            "file-list": _vm.fileList,
            "before-remove": _vm.handleBeforeRemove
          }
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { width: "100%" },
              attrs: { slot: "trigger", disabled: _vm.disabled },
              slot: "trigger"
            },
            [_vm._v("Click to upload")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.dialogVisible,
            modal: true,
            width: _vm.zoomInWidth
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: { src: _vm.dialogImageUrl, alt: "" }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0dbc72f1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dbc72f1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/upload/Image.vue
// module id = null
// module chunks = 